import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "66",
  height: "69",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F5F5F5",
      d: "M0 10.898c0-5.522 4.477-10 10-10h45.65c5.523 0 10 4.478 10 10V58.71c0 5.522-4.477 10-10 10H10c-5.523 0-10-4.478-10-10z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".3",
      stroke: "#fff",
      "stroke-width": ".5",
      d: "M33.988 50.645c-.53.2-.982.315-1.34.353V18.55a3.9 3.9 0 0 1 .901.206l12.94 5.161h.002c1.12.443 1.834 1.484 1.834 2.568 0 8.23-3.16 14.367-6.742 18.447-1.792 2.042-3.688 3.566-5.343 4.58-.828.506-1.593.883-2.252 1.133Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      stroke: "#fff",
      "stroke-width": ".5",
      d: "M31.237 18.706c.255-.056.616-.127.915-.157L32.092 51c-.352-.039-.8-.153-1.326-.352a13.7 13.7 0 0 1-2.24-1.126c-1.647-1.008-3.536-2.527-5.323-4.564-3.57-4.073-6.726-10.21-6.726-18.472 0-1.144.72-2.183 1.837-2.624z"
    }, null, -1)
  ])))
}
export default { render: render }